import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '@app/services/users.service';

@Injectable({ providedIn: 'root' })
export class LoginGuard {
    private readonly router = inject(Router);
    private readonly usersService = inject(UsersService);

    public async canActivate(): Promise<boolean> {
        const isTokenExpired = this.usersService.isTokenExpired();
        if (isTokenExpired) {
            await this.router.navigate(['/login']);
            return false;
        }

        const authenticated = await this.usersService.checkLogin();
        if (!authenticated) {
            await this.router.navigate(['/login']);
            return false;
        }
        return true;
    }
}
